var plp_toggle_default = (() => {
    if (customElements.get("plp-toggle")) return;
    customElements.define("plp-toggle", class PlpToggle extends HTMLElement {
        constructor() {
            super();
            this.boundClick = this.activate.bind(this);
            this.boundReflect = () => this.handleViewportChange();
        }
        connectedCallback() {
            this.button = this.querySelector("button");
            const targetSelector = this.dataset.target;
            this.target = targetSelector ? this.closest(targetSelector) : null;
            this.status = this.target ? this.target.querySelector(this.dataset.status) : null;
            const config = this.getConfig();
            if (!this.button || !this.target || !config) return;
            this.mql = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(min-width: 1025px)") : null;
            this.reflect(this.currentState());
            this.button.addEventListener("click", this.boundClick);
            if (this.mql) this.mql.addEventListener("change", this.boundReflect);
        }
        disconnectedCallback() {
            if (this.button) this.button.removeEventListener("click", this.boundClick);
            if (this.mql) this.mql.removeEventListener("change", this.boundReflect);
        }
        viewport() {
            return this.mql && this.mql.matches ? "desktop" : "mobile";
        }
        isViewportAware(config) {
            return !!(config && config.states && !Array.isArray(config.states));
        }
        getConfig() {
            return window.MBF?.strings?.collection?.grid?.[this.dataset.control] ?? null;
        }
        states(config) {
            return this.isViewportAware(config) ? config.states[this.viewport()] : config.states;
        }
        defaultState(config) {
            if (this.isViewportAware(config)) return config.defaults[this.viewport()];
            return this.target.getAttribute("data-" + this.dataset.control + "-default") || config.defaults;
        }
        currentState() {
            return this.target.getAttribute("data-" + this.dataset.control);
        }
        nextState(config, current) {
            const states = this.states(config);
            const index = states.indexOf(current);
            if (index === -1) return this.defaultState(config);
            return states[(index + 1) % states.length];
        }
        activate() {
            const config = this.getConfig();
            if (!config) return;
            this.notifyLayoutShift();
            const next = this.nextState(config, this.currentState());
            this.target.setAttribute("data-" + this.dataset.control, next);
            this.reflect(next);
            this.announce(config, next);
            this.emit(next);
        }
        handleViewportChange() {
            const config = this.getConfig();
            if (!config) return;
            if (this.isViewportAware(config)) {
                this.notifyLayoutShift();
                const reset = this.defaultState(config);
                this.target.setAttribute("data-" + this.dataset.control, reset);
                this.reflect(reset);
                this.announce(config, reset);
                this.emit(reset, "viewport");
            } else this.reflect(this.currentState());
        }
        notifyLayoutShift() {
            document.dispatchEvent(new CustomEvent("global-ui:suppress-header-scroll", {
                detail: {
                    duration: 300
                }
            }));
        }
        pick(map, state) {
            if (!map) return void 0;
            if (this.isViewportAware(this.getConfig())) {
                const vp = this.viewport();
                return map[vp] ? map[vp][state] : void 0;
            }
            return map[state];
        }
        reflect(state) {
            const config = this.getConfig();
            if (!config || !this.button) return;
            const ariaLabel = this.pick(config.ariaLabel, state);
            if (ariaLabel) this.button.setAttribute("aria-label", ariaLabel); else this.button.removeAttribute("aria-label");
            const isNonDefault = state !== this.defaultState(config);
            this.button.setAttribute("aria-pressed", String(isNonDefault));
            this.target.classList.toggle("is-" + this.dataset.control + "-swapped", isNonDefault);
        }
        announce(config, state) {
            if (!this.status) return;
            const message = this.pick(config.announce, state);
            if (message) this.status.textContent = message;
        }
        emit(value, source = "user") {
            this.target.dispatchEvent(new CustomEvent("plp-toggle:change", {
                bubbles: true,
                detail: {
                    control: this.dataset.control,
                    value: value,
                    source: source
                }
            }));
        }
    });
})();